import { Message } from 'stompjs';
import { useAppDispatch } from '../store/hooks';
import {
  joinTeam,
  leaveTeam,
  appendParticipant,
  removeParticipant,
  setHost,
  toggleReadyPlayer,
  addBot,
  removeBot
} from '../store/lobbySlice';

type Team = 'TEAM1' | 'TEAM2' | 'UNDEFINED';

interface BaseLobbyMessage {
  user: string;
  lobbyId: string;
}

interface JoinMessage extends BaseLobbyMessage {
  status: 'JOIN';
}

interface PickTeamMessage extends BaseLobbyMessage {
  status: 'PICK_TEAM';
  team: Team;
}

interface LeftMessage extends BaseLobbyMessage {
  status: 'LEFT';
}

interface HostChangedMessage {
  status: 'HOST_CHANGED';
  user: string;
}

interface ReadyUpdateMessage {
  status: 'READY_UPDATE';
  user: string;
  ready: boolean;
}

interface BotAddedMessage {
  status: 'BOT_ADDED';
  botName: string;
  team: 'TEAM1' | 'TEAM2';
  difficulty: string;
}

interface BotRemovedMessage {
  status: 'BOT_REMOVED';
  botName: string;
}

type LobbyMessage =
  | JoinMessage
  | PickTeamMessage
  | LeftMessage
  | HostChangedMessage
  | ReadyUpdateMessage
  | BotAddedMessage
  | BotRemovedMessage;

const useLobbyMessageHandler = () => {
  const dispatch = useAppDispatch();

  const onLobbyMessage = (payload: Message): void => {
    console.log(
      '%cWsContainer::onLobbyMessage:::::::::::::::::::::::::' + payload.body,
      'background-color: lightyellow'
    );

    const message: LobbyMessage = JSON.parse(payload.body);
    const { status } = message;

    switch (status) {
      case 'JOIN':
        dispatch(appendParticipant({ user: message.user }));
        break;

      case 'PICK_TEAM': {
        const { team, user } = message;
        if (team === 'UNDEFINED') {
          dispatch(leaveTeam({ team, user }));
        } else {
          dispatch(joinTeam({ team, user }));
        }
        break;
      }

      case 'LEFT':
        dispatch(removeParticipant({ user: message.user }));
        break;

      case 'HOST_CHANGED':
        dispatch(setHost(message.user));
        break;

      case 'READY_UPDATE':
        dispatch(toggleReadyPlayer({ user: message.user, ready: message.ready }));
        break;

      case 'BOT_ADDED':
        dispatch(addBot({ botName: message.botName, team: message.team, difficulty: message.difficulty }));
        break;

      case 'BOT_REMOVED':
        dispatch(removeBot({ botName: message.botName }));
        break;
    }
  };

  return onLobbyMessage;
};

export default useLobbyMessageHandler;
